import { create } from 'zustand';
import { TUserStore } from './UserStore.types';
import { TUser } from '../../services/user/user.types';
export const useUserStore = create<TUserStore>((set) => ({
	user: undefined,

	setUser: (user: TUser | undefined) => set({ user }),

	addNotificacao: (notificacao) =>
		set((state) => {
			if (!state.user) return state; // se não houver user, não faz nada
			return {
				user: {
					...state.user,
					notificacoes: [...(state.user.notificacoes ?? []), notificacao],
				},
			};
		}),

		removeNotificacao: (id: number) =>
			set((state) => ({
			user: state.user
				? {
					...state.user,
					notificacoes: state.user.notificacoes.filter(
					(n) => n.id_notificacao !== id
					),
				}
				: state.user,
			})),

	clearNotificacoes: () =>
		set((state) => {
			if (!state.user) return state;
			return {
				user: {
					...state.user,
					notificacoes: [],
				},
			};
		}),
}));
